import * as Types from './types';

const isApiError = <T>(response: Types.ApiResponse<T>): response is Types.ApiError =>
	(response as Types.ApiError).error !== undefined;

class SplashtechApiClient {
	private baseUrl = '/splashtech-service/client';

	private async request<T>(url: string, method = 'GET'): Promise<T> {
		const response = <Types.ApiResponse<T>>(
			await fetch(this.baseUrl + url, { method }).then(_response => _response.json())
		);

		if (isApiError(response)) {
			throw new Error(response.error);
		}
		return response;
	}

	public async fetchCampaignForUser() {
		return this.request<Types.SplashtechCampaignResponse>(`/campaign`);
	}

	public async fetchUserEligible() {
		return this.request<Types.SplastechEligible>(`/campaigns/eligible`);
	}

	public async checkUserNameExists(username: string) {
		return this.request<Types.CheckUsernameExistsResponse>(`/username/${username}`);
	}

	public async getCurrentPlayerUserName() {
		return this.request<Types.PlayerUsernameResponse>('/username');
	}

	public async createUsernameForPlayer(username: string) {
		return this.request<Types.RestResult>(`/username/${username}`, 'POST');
	}

	public async setPopupClosed() {
		return this.request<Types.RestResult>(`/player/popup/closed`, 'POST');
	}
}

export default new SplashtechApiClient();
